export default __webpack_public_path__ + "static/media/warning--roadworks--g11.65f561a7.png";